import { useMemo, useState } from "react";
import {
  getDefaultPrivacyPreferences,
  hasStoredPrivacyPreferences,
  savePrivacyPreferences,
} from "../../lib/privacyPreferences";

export function ConsentBanner() {
  const [dismissed, setDismissed] = useState(false);
  const hasStoredPreference = useMemo(() => hasStoredPrivacyPreferences(), []);

  if (dismissed || hasStoredPreference) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[1100] mx-auto max-w-[960px] rounded-[1.5rem] border border-black/10 bg-[rgba(247,245,240,0.96)] p-4 shadow-brand-shadow backdrop-blur">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="space-y-2">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-accent">
            Privacy controls
          </p>
          <p className="text-sm text-brand-ink leading-relaxed max-w-[68ch]">
            Diagnostics are off by default. You can keep them off or enable optional diagnostics to
            help improve reliability. AI processing and cloud sync stay user-triggered.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className="rounded-full border border-black/10 bg-white px-4 py-2 text-sm font-semibold text-brand-ink hover:bg-black/5 transition-colors"
            onClick={() => {
              savePrivacyPreferences(getDefaultPrivacyPreferences());
              setDismissed(true);
            }}
          >
            Keep diagnostics off
          </button>
          <button
            type="button"
            className="rounded-full bg-brand-accent px-4 py-2 text-sm font-semibold text-white hover:bg-brand-accent-strong transition-colors"
            onClick={() => {
              savePrivacyPreferences({ diagnosticsEnabled: true });
              setDismissed(true);
            }}
          >
            Enable diagnostics
          </button>
        </div>
      </div>
    </div>
  );
}
